import {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {I18n, Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import TextField from '@material-ui/core/TextField';
import {DOCUMENT_STATES_VALID} from 'front-onceforall-core/dist/utils/documents';
import {connect} from 'react-redux';
import removeAccents from 'remove-accents';
import documentService from '../../services/document/DocumentService';
import DocumentListArchived from '../../components/documentListArchived';
import authenticationService from '../../services/authentication/AuthenticationService';
import {openOrSaveFile} from '../../utils/http';
import {recordGAEvent} from '../../utils/analytics';

export class MyArchiveDocumentsView extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      archivedDocuments: [],
      filteredDocuments: [],
      searchDocumentValue: '',
      loading: true,
      loadingDownloadArchive: false
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleShowDocuments = this.handleShowDocuments.bind(this);
    this.handleDownloadArchivesDossier = this.handleDownloadArchivesDossier.bind(this);
  }

  componentDidMount() {
    this.setState({loading: true});

    documentService.getArchivedDocuments(this.props.organisation.organisationId)
      .then(response => {
        // In FO, we only want to see valid archived documents
        const archivedDocuments = response
          .filter(document => DOCUMENT_STATES_VALID.includes(document.state))
          .map(document => ({...document, searchValue: removeAccents(document.type.name.toLowerCase())}));
        this.setState({archivedDocuments, loading: false}, this.filterDocuments);
      })
      .catch(() => {
        this.setState({
          archivedDocuments: [],
          loading: false
        });
      });
  }

  handleDownloadArchivesDossier() {
    if (!this.state.archivedDocuments.length) {
      return;
    }

    recordGAEvent('SUPPLIER_ARCHIVES', 'Download archives');
    this.setState({loadingDownloadArchive: true});
    authenticationService.authRedirect(
      documentService.getDossierArchivesZipUrl(this.props.organisation.organisationId)
    )
      .then(authUrl => {
        openOrSaveFile(authUrl);
        this.setState({loadingDownloadArchive: false});
      });
  }

  handleShowDocuments() {
    this.props.history.push('/documents');
  }

  handleSearchChange(event) {
    const searchDocumentValue = event.target.value;
    this.setState({searchDocumentValue}, this.filterDocuments);
  }

  filterDocuments() {
    let filteredDocuments = this.state.archivedDocuments;
    if (this.state.searchDocumentValue.length > 0) {
      const searchDocumentValueNormalized = removeAccents(this.state.searchDocumentValue.toLowerCase());
      if (searchDocumentValueNormalized.length > 0) {
        filteredDocuments = filteredDocuments.filter(document => document.searchValue.indexOf(searchDocumentValueNormalized) !== -1);
      }
    }

    this.setState({filteredDocuments});
  }

  render() {
    return (
      <>
        {this.state.loading && <div className="loading-overlay"/>}
        <div className="col-12 mt-4 inline-container space-between">
          <div className="inline-container">
            <button
              title={I18n.t('document.consultMyDocuments')}
              type="button"
              className="inline-container secondary large"
              onClick={this.handleShowDocuments}
            >
              <Icon icon="go-back"/>
            </button>
            <h1 className="m-0 ml-4">
              <Translate value="document.myArchivedDocuments"/>
              <span className="separator information">{this.state.archivedDocuments.length}</span>
            </h1>
          </div>
          <button
            data-id="download-archives"
            type="button"
            className="large cta inline-container no-wrap"
            onClick={this.handleDownloadArchivesDossier}
            disabled={this.state.archivedDocuments.length < 1}
          >
            <Icon icon={this.state.loadingDownloadArchive ? 'loader' : 'download'}/>
            <Translate value="dossier.download.standardArchives"/>
          </button>
        </div>
        <div className="card inline-container col-12 my-4">
          <TextField
            label={<div className="inline-container">
              <Icon icon="mag-glass"/>
              <Translate value="document.searchArchiveBar"/>
            </div>}
            value={this.state.searchDocumentValue}
            onChange={this.handleSearchChange}
            disabled={this.state.loading}
          />
        </div>
        <DocumentListArchived
          documents={this.state.filteredDocuments}
          onDownloadDocumentFile={() => recordGAEvent('SUPPLIER_DOCUMENT_HISTORY', 'Download historical document')}
        />
        {this.state.archivedDocuments.length > 0 && this.state.filteredDocuments.length < 1 &&
        <div className="table-without-result">
          <Translate value="document.noResultMatch"/>
        </div>
        }
        {this.state.archivedDocuments.length < 1 &&
        <div className="table-without-result">
          <Translate value="document.noArchive"/>
        </div>
        }
      </>
    );
  }
}

MyArchiveDocumentsView.propTypes = {
  organisation: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

export default withRouter(connect(mapStateToProps, null)(MyArchiveDocumentsView));
